// extracted by mini-css-extract-plugin
export default {"subTitle":"collectData_subTitle__tZeeI","dataWrapper":"collectData_dataWrapper__YCDGU","list":"collectData_list__VhjZb","label":"collectData_label__rClnO"};